module.exports = __webpack_public_path__ + "static/media/survive.9b744775.wav";